import React from "react";
import FlipMove from "react-flip-move";
import { useSelector } from "react-redux";
import { selectBasket } from "../features/basketSlice";
import "./Checkout.css";
import CheckoutProduct from "./CheckoutProduct";
import Subtotal from "./Subtotal";

function Checkout() {
  const basket = useSelector(selectBasket);
  return (
    <div className="checkout">
      <div className="checkout__left">
        <img
          className="checkout__ad"
          src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg"
          alt=""
        />
        <div>
          <h2 className="checkout__title">
            <FlipMove leaveAnimation="fade">
              {basket.map((item) => {
                return (
                  <CheckoutProduct
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    price={item.price}
                    originalPrice={item.originalPrice}
                    image={item.image}
                    rating={item.rating}
                    quantity={item?.quantity}
                  />
                );
              })}
            </FlipMove>
          </h2>
        </div>
      </div>

      <div className="checkout__right">
        <Subtotal />
      </div>
    </div>
  );
}

export default Checkout;
